import * as superagent from 'superagent';
import { UserState } from 'app/reducers';
// Using URLSearchParams instead of Node.js querystring for browser compatibility

export function API_BASE() { 
    try {
        if (window['IN_DEV_MODE'] === true) {
            return 'https://drg3dwm9kd.execute-api.us-east-1.amazonaws.com/dev/';
        }
    }
    catch(e) {

    }
    return 'https://api.vleader.net/'; 
}

export function API_CHARTBACK() {
    try {
        if (window['IN_DEV_MODE'] === true) {
            return 'https://6c4tcqya4j.execute-api.us-east-1.amazonaws.com/dev/index';
        }
    }
    catch(e) {}
    return 'https://e2xpk868lg.execute-api.us-east-1.amazonaws.com/prod/index';
}

export function getKryBase(user: UserState) {
    try {
        if (window['IN_DEV_MODE'] === true) {
            return 'https://zm9vi2b5q9.execute-api.us-east-1.amazonaws.com/dev/';
        }
    }
    catch(e) {
        return 'https://zm9vi2b5q9.execute-api.us-east-1.amazonaws.com/dev/';
    }

    return 'https://ajwrrfj6wi.execute-api.us-east-1.amazonaws.com/prod/';
}

export function executeQueryAuthPostForm(route:string, payload: any, callback: (response: any) => void) {
    executeQueryPost(route, payload, callback);
}

export function executeQueryPost(route:string, payload: any, callback: (response: any) => void) {
    // Wrap the request in a super agent
    superagent.
        post(API_BASE() + route).
        send(new URLSearchParams(payload).toString()).
        end((error:any, response:any) => {
            if (error) {
                console.error(error);
            }
            callback(wrapResponseForError(response));
        }); 
}

export function executeInlineAuthGet(route: string, payload: any, auth: string, callback: (response:any) => void) {
    superagent.
        get(API_BASE() + route).
        send(payload).
        set('Token', auth).
        end((error:any, response:any) => {
            if (error) {
                console.error(error);
            }
            callback(wrapResponseForError(response));
        }); 
}

export function executeQueryGet(route: string, payload: any, callback: (response: any) => void) {
    // Wrap the request in a super agent
    superagent.
        get(API_BASE() + route).
        send(payload).
        end((error:any, response:any) => {
            if (error) {
                console.error(error);
            }
            callback(wrapResponseForError(response));
        }); 
}

export function executeQueryGetAuth(route: string, payload: any, user: UserState, callback: (response: any) => void) {
    // Wrap the request in a super agent
    superagent.
        get(API_BASE() + route).
        send(payload).
        set('Token', user.authenticationToken).
        end((error:any, response:any) => {
            if (error) {
                console.error(error);
            }

            // check if response has contentLocation as a JSOn value, if so get that
            // and return it's value instead
            let useFollowup = false;

            try {
                const b = JSON.parse(response.text);
                if (b['contentLocation']) {
                    useFollowup = true;
                    superagent.
                    get(b['contentLocation'])
                    .end((error2:any, response2:any) => {
                        if (error2) {
                            console.error(error);
                        }
                        callback(wrapResponseForError(response2));
                    });
                }
            }
            catch(e) {

            }

            if (useFollowup) {

            }
            else {
                callback(wrapResponseForError(response));
            }
        }); 
}


export function executeQueryPutAuth(route:string, payload: any, user: UserState, callback: (response: any) => void) {
    // Wrap the request in a super agent
    superagent.
        put(API_BASE() + route).
        send(new URLSearchParams(payload).toString()).
        set('Token', user.authenticationToken).
        end((error:any, response:any) => {
            if (error) {
                console.error(error);
            }
            callback(wrapResponseForError(response));
        }); 
}

export function executeQueryPostAuth(route:string, payload: any, user: UserState, callback: (response: any) => void) {
    // Wrap the request in a super agent
    superagent.
        post(API_BASE() + route).
        send(new URLSearchParams(payload).toString()).
        set('Token', user.authenticationToken).
        end((error:any, response:any) => {
            if (error) {
                console.error(error);
            }
            callback(wrapResponseForError(response));
        }); 
}

export function executeQueryDeleteAuth(route:string, payload: any, user: UserState, callback: (response: any) => void) {
    // Wrap the request in a super agent
    superagent.
        delete(API_BASE() + route).
        send(payload).
        set('Token', user.authenticationToken).
        end((error:any, response:any) => {
            if (error) {
                console.error(error);
            }
            callback(wrapResponseForError(response));
        }); 
}

export function cleanParsedPayloadSet(payloadSets: any) {
    for (let i = 0; i < payloadSets.length; i++) {
        const payloadAsString = payloadSets[i]["payload"];

        payloadSets[i]["payload"] = JSON.parse(payloadAsString);
    }

    return payloadSets;
}

// Make sure "invalid" JSON doesn't cause unnecessary error clutter
function wrapResponseForError(response: any) {
    const FALLBACK_RESPONSE = "{}";

    // Handle case where response is undefined or null
    if (!response) {
        return { text: FALLBACK_RESPONSE };
    }

    try {
        JSON.parse(response.text);

        return response;
    }
    catch(e) {

    }

    response.text = FALLBACK_RESPONSE;
    return response;
}
